<template>
    <div class="max-width-content">

        <breadcrumbs>
            <inertia-link href="/users">Werkzoekenden</inertia-link>
            <i class="fad fa-chevron-right"></i>
            <inertia-link :href="route('admin.users.show', user.id)">{{ user.fullName }}</inertia-link>
            <i class="fad fa-chevron-right"></i>
            Wijzig
        </breadcrumbs>

        <div class="mt-5 bg-white rounded-lg px-8 py-5">
            <user-form :user="user" @submit="submit" :data-loading="loading"></user-form>
        </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import UserForm from "@/admin/Pages/Users/UserForm";

export default {
    metaInfo() {
        return { title: 'Gebruikers > ' + this.user.fullName };
    },

    layout: (h, page) => h(Layout, [page]),

    components: {
        Breadcrumbs,
        UserForm
    },

    mixins: [Helpers],

    props: {
        user: Object
    },

    remember: "form",

    data() {
        return {

        };
    },

    methods: {
        submit(data) {
            this.loading = "submit";

            const url = this.route("admin.users.update", this.user.id).url();
            data.append("_method", "patch");
            const options = { onFinish: () => this.loading = false}

            this.$inertia.post(url, data, options)
        },

        destroy() {
            this.loading = "delete";
            if (confirm("Are you sure you want to delete this user?")) {
                const url = this.route("admin.users.destroy", this.user.id)
                const options = { onFinish: () => this.loading = false}

                this.$inertia.delete(url, options)
            }
        },

    }
};
</script>
